import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { theme } from '@Guidelines/Theme/theme';
import LimitRow from '@UI/Pages/Administration/AiCostLimits/Sections/LevelLimits/LimitRow';
import { openAiCostLimitCreation } from '@UI/Pages/Administration/Shared/Signals/aiCostLimitSidebarSignal';
import { css } from '@emotion/react';
import { Plus } from 'lucide-react';
import * as React from 'react';
import { useSelector } from '@verclam/synapse';
import { Button } from '@verclam/ui-kit';

const sectionStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
`;

const titleStyle = css`
	${theme.typography.sectionTitle}
	margin: 0;
	color: ${theme.colors.ink};
`;

const emptyTextStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.inkSecondary};
`;

const emptyStyle = css`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 1rem;
`;

/** The account's own limit, shown as a single card, or an invitation to define one. */
const AccountLimit: React.FC = () => {
	const limits = useSelector((state) => state.aiCostLimitsStore.limits);
	const accountLimit = limits?.ofLevel('account')[0] ?? null;

	const handleDefineClick = React.useCallback(() => {
		openAiCostLimitCreation('account');
	}, []);

	return (
		<section css={sectionStyle}>
			<h2 css={titleStyle}>Compte</h2>
			<ConditionalLoader
				data={accountLimit}
				fallback={
					<div css={emptyStyle}>
						<p css={emptyTextStyle}>
							Aucun plafond : la consommation du compte n'est pas limitée.
						</p>
						<Button
							type="button"
							severity="secondary"
							label="Définir un plafond"
							icon={<Plus size={16} />}
							onClick={handleDefineClick}
						/>
					</div>
				}
			>
				{(limit) => <LimitRow limit={limit} subjectName="Compte" />}
			</ConditionalLoader>
		</section>
	);
};

export default AccountLimit;
